import React from 'react';
import {
  BlockInteractions,
  createButtonObject,
  DISPLAY_TYPE,
  Views,
} from '../../components/organisms/BlockInteractions';

import { Icons } from '../../components/atoms/SVG';
import { PortalThemeDefaultView } from './partials/ThemeColorDefaultView';
import { ThemeColorEditView } from './partials/ThemeColorEditView';
import { Namespace } from '../../translation/namespace';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { DefaultView, LazyEditView, Views as BlockWithViews } from '../../types/BlockWithViews';
import { asBlock, useBlockContext } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';

type PortalThemeHighlightColor = BlockWithViews<DefaultView<any> & LazyEditView>;

function PortalThemeHighlightColor({ views, activeView }: PortalThemeHighlightColor) {
  const { t } = useSonTranslation('ThemeColorForm');
  const { uuid, elementType } = useBlockContext();

  const headline = {
    text: t('headline'),
    hierarchy: 2,
    visible: true,
  };

  const buttons = createButtonObject(
    Views.EDIT,
    Icons.EDIT_PENCIL,
    `${Namespace.ThemeColorForm}:edit`,
    DISPLAY_TYPE.COLLAPSIBLE,
    <ThemeColorEditView {...views.edit} />,
  );

  return (
    <BlockInteractions
      headline={headline}
      alwaysShowInfo
      views={views}
      activeView={activeView}
      buttons={buttons}
      uuid={uuid}
      elementType={elementType}
    >
      <PortalThemeDefaultView {...views.default} />
    </BlockInteractions>
  );
}

export const PortalThemeHighlightColorBlock = asBlock(PortalThemeHighlightColor, BlockType.portalThemeHighlightColor);
